import React from "react";
export const punish = () => {
  return (
    <div className="opinion-wrap">
      <h1>中华人民共和国治安管理处罚法</h1>
      <div className="text-cont">
        <br />
        <br />
        第一章　总则 　　 <br />
        <br />
        第一条　为维护社会治安秩序，保障公共安全，保护公民、法人和其他组织的合法权益，规范和保障公安机关及其人民警察依法履行治安管理职责，制定本法。
        　　 <br />
        <br />
        第二条　扰乱公共秩序，妨害公共安全，侵犯人身权利、财产权利，妨害社会管理，具有社会危害性，依照《中华人民共和国刑法》的规定构成犯罪的，依法追究刑事责任；尚不够刑事处罚的，由公安机关依照本法给予治安管理处罚。
        　　 <br />
        <br />
        第三条　治安管理处罚的程序，适用本法的规定；本法没有规定的，适用《中华人民共和国行政处罚法》的有关规定。
        　　 <br />
        <br />
        第四条　在中华人民共和国领域内发生的违反治安管理行为，除法律有特别规定的外，适用本法。
        　　在中华人民共和国船舶和航空器内发生的违反治安管理行为，除法律有特别规定的外，适用本法。
        　　 <br />
        <br />
        第五条　治安管理处罚必须以事实为依据，与违反治安管理行为的性质、情节以及社会危害程度相当。
        　　实施治安管理处罚，应当公开、公正，尊重和保障人权，保护公民的人格尊严。
        　　办理治安案件应当坚持教育与处罚相结合的原则。 　　 <br />
        <br />
        第六条　各级人民政府应当加强社会治安综合治理，采取有效措施，化解社会矛盾，增进社会和谐，维护社会稳定。
        　　 <br />
        <br />
        第七条　国务院公安部门负责全国的治安管理工作。县级以上地方各级人民政府公安机关负责本行政区域内的治安管理工作。
        　　治安案件的管辖由国务院公安部门规定。 　　 <br />
        <br />
        第八条　违反治安管理的行为对他人造成损害的，行为人或者其监护人应当依法承担民事责任。
        　　 <br />
        <br />
        第九条　对于因民间纠纷引起的打架斗殴或者损毁他人财物等违反治安管理行为，情节较轻的，公安机关可以调解处理。经公安机关调解，当事人达成协议的，不予处罚。经调解未达成协议或者达成协议后不履行的，公安机关应当依照本法的规定对违反治安管理行为人给予处罚，并告知当事人可以就民事争议依法向人民法院提起民事诉讼。
        <br />
        <br />
        第二章　处罚的种类和适用 　　 <br />
        <br />
        第十条　治安管理处罚的种类分为: 　　 <br />
        <br />
        （一）警告； 　　 <br />
        <br />
        （二）罚款； 　　 <br />
        <br />
        （三）行政拘留； 　　 <br />
        <br />
        （四）吊销公安机关发放的许可证。
        　　对违反治安管理的外国人，可以附加适用限期出境或者驱逐出境。 　　{" "}
        <br />
        <br />
        第十一条　办理治安案件所查获的毒品、淫秽物品等违禁品，赌具、赌资，吸食、注射毒品的用具以及直接用于实施违反治安管理行为的本人所有的工具，应当收缴，按照规定处理。
        　　违反治安管理所得的财物，追缴退还被侵害人；没有被侵害人的，登记造册，公开拍卖或者按照国家有关规定处理，所得款项上缴国库。
        　　 <br />
        <br />
        第十二条　已满十四周岁不满十八周岁的人违反治安管理的，从轻或者减轻处罚；不满十四周岁的人违反治安管理的，不予处罚，但是应当责令其监护人严加管教。
        　　 <br />
        <br />
        第十三条　精神病人在不能辨认或者不能控制自己行为的时候违反治安管理的，不予处罚，但是应当责令其监护人严加看管和治疗。间歇性的精神病人在精神正常的时候违反治安管理的，应当给予处罚。
        　　 <br />
        <br />
        第十四条　盲人或者又聋又哑的人违反治安管理的，可以从轻、减轻或者不予处罚。
        　　 <br />
        <br />
        第十五条　醉酒的人违反治安管理的，应当给予处罚。
        　　醉酒的人在醉酒状态中，对本人有危险或者对他人的人身、财产或者公共安全有威胁的，应当对其采取保护性措施约束至酒醒。
        　　 <br />
        <br />
        第十六条　有两种以上违反治安管理行为的，分别决定，合并执行。行政拘留处罚合并执行的，最长不超过二十日。
        　　 <br />
        <br />
        第十七条　共同违反治安管理的，根据违反治安管理行为人在违反治安管理行为中所起的作用，分别处罚。
        　　教唆、胁迫、诱骗他人违反治安管理的，按照其教唆、胁迫、诱骗的行为处罚。
        　　 <br />
        <br />
        第十八条　单位违反治安管理的，对其直接负责的主管人员和其他直接责任人员依照本法的规定处罚。其他法律、行政法规对同一行为规定给予单位处罚的，依照其规定处罚。
        　　 <br />
        <br />
        第十九条　违反治安管理有下列情形之一的，减轻处罚或者不予处罚: 　　{" "}
        <br />
        <br />
        （一）情节特别轻微的； 　　 <br />
        <br />
        （二）主动消除或者减轻违法后果，并取得被侵害人谅解的； 　　 <br />
        <br />
        （三）出于他人胁迫或者诱骗的； 　　 <br />
        <br />
        （四）主动投案，向公安机关如实陈述自己的违法行为的； 　　 <br />
        <br />
        （五）有立功表现的。 　　 <br />
        <br />
        第二十条　违反治安管理有下列情形之一的，从重处罚: 　　 <br />
        <br />
        （一）有较严重后果的； 　　 <br />
        <br />
        （二）教唆、胁迫、诱骗他人违反治安管理的； 　　 <br />
        <br />
        （三）对报案人、控告人、举报人、证人打击报复的； 　　 <br />
        <br />
        （四）六个月内曾受过治安管理处罚的。 　　 <br />
        <br />
        第二十一条　违反治安管理行为人有下列情形之一，依照本法应当给予行政拘留处罚的，不执行行政拘留处罚:
        　　 <br />
        <br />
        （一）已满十四周岁不满十六周岁的； 　　 <br />
        <br />
        （二）已满十六周岁不满十八周岁，初次违反治安管理的； 　　 <br />
        <br />
        （三）七十周岁以上的； 　　 <br />
        <br />
        （四）怀孕或者哺乳自己不满一周岁婴儿的。 　　 <br />
        <br />
        第二十二条　违反治安管理行为在六个月内没有被公安机关发现的，不再处罚。
        　　前款规定的期限，从违反治安管理行为发生之日起计算；违反治安管理行为有连续或者继续状态的，从行为终了之日起计算。
        <br />
        <br />
        第三章　违反治安管理的行为和处罚 <br />
        <br />
        第一节　扰乱公共秩序的行为和处罚 　　 <br />
        <br />
        第二十三条　有下列行为之一的，处警告或者二百元以下罚款；情节较重的，处五日以上十日以下拘留，可以并处五百元以下罚款:
        　　 <br />
        <br />
        （一）扰乱机关、团体、企业、事业单位秩序，致使工作、生产、营业、医疗、教学、科研不能正常进行，尚未造成严重损失的；
        　　 <br />
        <br />
        （二）扰乱车站、港口、码头、机场、商场、公园、展览馆或者其他公共场所秩序的；
        　　 <br />
        <br />
        （三）扰乱公共汽车、电车、火车、船舶、航空器或者其他公共交通工具上的秩序的；
        　　 <br />
        <br />
        （四）非法拦截或者强登、扒乘机动车、船舶、航空器以及其他交通工具，影响交通工具正常行驶的；
        　　 <br />
        <br />
        （五）破坏依法进行的选举秩序的。
        　　聚众实施前款行为的，对首要分子处十日以上十五日以下拘留，可以并处一千元以下罚款。
        　　 <br />
        <br />
        第二十四条　有下列行为之一，扰乱文化、体育等大型群众性活动秩序的，处警告或者二百元以下罚款；情节严重的，处五日以上十日以下拘留，可以并处五百元以下罚款:
        　　 <br />
        <br />
        （一）强行进入场内的； 　　 <br />
        <br />
        （二）违反规定，在场内燃放烟花爆竹或者其他物品的； 　　 <br />
        <br />
        （三）展示侮辱性标语、条幅等物品的； 　　 <br />
        <br />
        （四）围攻裁判员、运动员或者其他工作人员的； 　　 <br />
        <br />
        （五）向场内投掷杂物，不听制止的； 　　 <br />
        <br />
        （六）扰乱大型群众性活动秩序的其他行为。
        　　因扰乱体育比赛秩序被处以拘留处罚的，可以同时责令其十二个月内不得进入体育场馆观看同类比赛；违反规定进入体育场馆的，强行带离现场。
        　　 <br />
        <br />
        第二十五条　有下列行为之一的，处五日以上十日以下拘留，可以并处五百元以下罚款；情节较轻的，处五日以下拘留或者五百元以下罚款:
        　　 <br />
        <br />
        （一）散布谣言，谎报险情、疫情、警情或者以其他方法故意扰乱公共秩序的；
        　　 <br />
        <br />
        （二）投放虚假的爆炸性、毒害性、放射性、腐蚀性物质或者传染病病原体等危险物质扰乱公共秩序的；
        　　 <br />
        <br />
        （三）扬言实施放火、爆炸、投放危险物质扰乱公共秩序的。 　　 <br />
        <br />
        第二十六条　有下列行为之一的，处五日以上十日以下拘留，可以并处五百元以下罚款；情节较重的，处十日以上十五日以下拘留，可以并处一千元以下罚款:
        　　 <br />
        <br />
        （一）结伙斗殴的； 　　 <br />
        <br />
        （二）追逐、拦截他人的； 　　 <br />
        <br />
        （三）强拿硬要或者任意损毁、占用公私财物的； 　　 <br />
        <br />
        （四）其他寻衅滋事行为。 　　 <br />
        <br />
        第二十七条　有下列行为之一的，处十日以上十五日以下拘留，可以并处一千元以下罚款；情节较轻的，处五日以上十日以下拘留，可以并处五百元以下罚款:
        　　 <br />
        <br />
        （一）组织、教唆、胁迫、诱骗、煽动他人从事邪教、会道门活动或者利用邪教、会道门、迷信活动，扰乱社会秩序、损害他人身体健康的；
        　　 <br />
        <br />
        （二）冒用宗教、气功名义进行扰乱社会秩序、损害他人身体健康活动的。 　　{" "}
        <br />
        <br />
        第二十八条　违反国家规定，故意干扰无线电业务正常进行的，或者对正常运行的无线电台{" "}
        （站）产生有害干扰，经有关主管部门指出后，拒不采取有效措施消除的，处五日以上十日以下拘留；情节严重的，处十日以上十五日以下拘留。
        　　 <br />
        <br />
        第二十九条　有下列行为之一的，处五日以下拘留；情节较重的，处五日以上十日以下拘留:
        　　 <br />
        <br />
        （一）违反国家规定，侵入计算机信息系统，造成危害的； 　　 <br />
        <br />
        （二）违反国家规定，对计算机信息系统功能进行删除、修改、增加、干扰，造成计算机信息系统不能正常运行的；
        　　 <br />
        <br />
        （三）违反国家规定，对计算机信息系统中存储、处理、传输的数据和应用程序进行删除、修改、增加的；
        　　 <br />
        <br />
        （四）故意制作、传播计算机病毒等破坏性程序，影响计算机信息系统正常运行的。
        <br />
        <br />
        第二节　妨害公共安全的行为和处罚 　　 <br />
        <br />
        第三十条　违反国家规定，制造、买卖、储存、运输、邮寄、携带、使用、提供、处置爆炸性、毒害性、放射性、腐蚀性物质或者传染病病原体等危险物质的，处十日以上十五日以下拘留；情节较轻的，处五日以上十日以下拘留。
        　　 <br />
        <br />
        第三十一条　爆炸性、毒害性、放射性、腐蚀性物质或者传染病病原体等危险物质被盗、被抢或者丢失，未按规定报告的，处五日以下拘留；故意隐瞒不报的，处五日以上十日以下拘留。
        　　 <br />
        <br />
        第三十二条　非法携带枪支、弹药或者弩、匕首等国家规定的管制器具的，处五日以下拘留，可以并处五百元以下罚款；情节较轻的，处警告或者二百元以下罚款。
        　　非法携带枪支、弹药或者弩、匕首等国家规定的管制器具进入公共场所或者公共交通工具的，处五日以上十日以下拘留，可以并处五百元以下罚款。
        　　 <br />
        <br />
        第三十三条　有下列行为之一的，处十日以上十五日以下拘留: 　　 <br />
        <br />
        （一）盗窃、损毁油气管道设施、电力电信设施、广播电视设施、水利防汛工程设施或者水文监测、测量、气象测报、环境监测、地质监测、地震监测等公共设施的；
        　　 <br />
        <br />
        （二）移动、损毁国家边境的界碑、界桩以及其他边境标志、边境设施或者领土、领海标志设施的；
        　　 <br />
        <br />
        （三）非法进行影响国 <br />
        <br />
        （边）界线走向的活动或者修建有碍国 <br />
        <br />
        （边）境管理的设施的。 　　 <br />
        <br />
        第三十四条　盗窃、损坏、擅自移动使用中的航空设施，或者强行进入航空器驾驶舱的，处十日以上十五日以下拘留。
        　　在使用中的航空器上使用可能影响导航系统正常功能的器具、工具，不听劝阻的，处五日以下拘留或者五百元以下罚款。
        　　 <br />
        <br />
        第三十五条　有下列行为之一的，处五日以上十日以下拘留，可以并处五百元以下罚款；情节较轻的，处五日以下拘留或者五百元以下罚款:
        　　 <br />
        <br />
        （一）盗窃、损毁或者擅自移动铁路设施、设备、机车车辆配件或者安全标志的；
        　　 <br />
        <br />
        （二）在铁路线路上放置障碍物，或者故意向列车投掷物品的； 　　 <br />
        <br />
        （三）在铁路线路、桥梁、涵洞处挖掘坑穴、采石取沙的； 　　 <br />
        <br />
        （四）在铁路线路上私设道口或者平交过道的。 　　 <br />
        <br />
        第三十六条　擅自进入铁路防护网或者火车来临时在铁路线路上行走坐卧、抢越铁路，影响行车安全的，处警告或者二百元以下罚款。
        　　 <br />
        <br />
        第三十七条　有下列行为之一的，处五日以下拘留或者五百元以下罚款；情节严重的，处五日以上十日以下拘留，可以并处五百元以下罚款:
        　　 <br />
        <br />
        （一）未经批准，安装、使用电网的，或者安装、使用电网不符合安全规定的；
        　　 <br />
        <br />
        （二）在车辆、行人通行的地方施工，对沟井坎穴不设覆盖物、防围和警示标志的，或者故意损毁、移动覆盖物、防围和警示标志的；
        　　 <br />
        <br />
        （三）盗窃、损毁路面井盖、照明等公共设施的。 　　 <br />
        <br />
        第三十八条　举办文化、体育等大型群众性活动，违反有关规定，有发生安全事故危险的，责令停止活动，立即疏散；对组织者处五日以上十日以下拘留，并处二百元以上五百元以下罚款；情节较轻的，处五日以下拘留或者五百元以下罚款。
        　　 <br />
        <br />
        第三十九条　旅馆、饭店、影剧院、娱乐场、运动场、展览馆或者其他供社会公众活动的场所的经营管理人员，违反安全规定，致使该场所有发生安全事故危险，经公安机关责令改正，拒不改正的，处五日以下拘留。
        <br />
        <br />
        第三节　侵犯人身权利、财产权利的行为和处罚 　　 <br />
        <br />
        第四十条　有下列行为之一的，处十日以上十五日以下拘留，并处五百元以上一千元以下罚款；情节较轻的，处五日以上十日以下拘留，并处二百元以上五百元以下罚款:
        　　 <br />
        <br />
        （一）组织、胁迫、诱骗不满十六周岁的人或者残疾人进行恐怖、残忍表演的；
        　　 <br />
        <br />
        （二）以暴力、威胁或者其他手段强迫他人劳动的； 　　 <br />
        <br />
        （三）非法限制他人人身自由、非法侵入他人住宅或者非法搜查他人身体的。
        　　 <br />
        <br />
        第四十一条　胁迫、诱骗或者利用他人乞讨的，处十日以上十五日以下拘留，可以并处一千元以下罚款。
        　　反复纠缠、强行讨要或者以其他滋扰他人的方式乞讨的，处五日以下拘留或者警告。
        　　 <br />
        <br />
        第四十二条　有下列行为之一的，处五日以下拘留或者五百元以下罚款；情节较重的，处五日以上十日以下拘留，可以并处五百元以下罚款:
        　　 <br />
        <br />
        （一）写恐吓信或者以其他方法威胁他人人身安全的； 　　 <br />
        <br />
        （二）公然侮辱他人或者捏造事实诽谤他人的； 　　 <br />
        <br />
        （三）捏造事实诬告陷害他人，企图使他人受到刑事追究或者受到治安管理处罚的；
        　　 <br />
        <br />
        （四）对证人及其近亲属进行威胁、侮辱、殴打或者打击报复的； 　　 <br />
        <br />
        （五）多次发送淫秽、侮辱、恐吓或者其他信息，干扰他人正常生活的； 　　{" "}
        <br />
        <br />
        （六）偷窥、偷拍、窃听、散布他人隐私的。 　　 <br />
        <br />
        第四十三条　殴打他人的，或者故意伤害他人身体的，处五日以上十日以下拘留，并处二百元以上五百元以下罚款；情节较轻的，处五日以下拘留或者五百元以下罚款。
        　　有下列情形之一的，处十日以上十五日以下拘留，并处五百元以上一千元以下罚款:
        　　 <br />
        <br />
        （一）结伙殴打、伤害他人的； 　　 <br />
        <br />
        （二）殴打、伤害残疾人、孕妇、不满十四周岁的人或者六十周岁以上的人的；
        　　 <br />
        <br />
        （三）多次殴打、伤害他人或者一次殴打、伤害多人的。 　　 <br />
        <br />
        第四十四条　猥亵他人的，或者在公共场所故意裸露身体，情节恶劣的，处五日以上十日以下拘留；猥亵智力残疾人、精神病人、不满十四周岁的人或者有其他严重情节的，处十日以上十五日以下拘留。
        　　 <br />
        <br />
        第四十五条　有下列行为之一的，处五日以下拘留或者警告: 　　 <br />
        <br />
        （一）虐待家庭成员，被虐待人要求处理的； 　　 <br />
        <br />
        （二）遗弃没有独立生活能力的被扶养人的。 　　 <br />
        <br />
        第四十六条　强买强卖商品，强迫他人提供服务或者强迫他人接受服务的，处五日以上十日以下拘留，并处二百元以上五百元以下罚款；情节较轻的，处五日以下拘留或者五百元以下罚款。
        　　 <br />
        <br />
        第四十七条　煽动民族仇恨、民族歧视，或者在出版物、计算机信息网络中刊载民族歧视、侮辱内容的，处十日以上十五日以下拘留，可以并处一千元以下罚款。
        　　 <br />
        <br />
        第四十八条　冒领、隐匿、毁弃、私自开拆或者非法检查他人邮件的，处五日以下拘留或者五百元以下罚款。
        　　 <br />
        <br />
        第四十九条　盗窃、诈骗、哄抢、抢夺、敲诈勒索或者故意损毁公私财物的，处五日以上十日以下拘留，可以并处五百元以下罚款；情节较重的，处十日以上十五日以下拘留，可以并处一千元以下罚款。
        <br />
        <br />
        第四节　妨害社会管理的行为和处罚 　　 <br />
        <br />
        第五十条　有下列行为之一的，处警告或者二百元以下罚款；情节严重的，处五日以上十日以下拘留，可以并处五百元以下罚款:
        　　 <br />
        <br />
        （一）拒不执行人民政府在紧急状态情况下依法发布的决定、命令的； 　　{" "}
        <br />
        <br />
        （二）阻碍国家机关工作人员依法执行职务的； 　　 <br />
        <br />
        （三）阻碍执行紧急任务的消防车、救护车、工程抢险车、警车等车辆通行的；
        　　 <br />
        <br />
        （四）强行冲闯公安机关设置的警戒带、警戒区的。
        　　阻碍人民警察依法执行职务的，从重处罚。 　　 <br />
        <br />
        第五十一条　冒充国家机关工作人员或者以其他虚假身份招摇撞骗的，处五日以上十日以下拘留，可以并处五百元以下罚款；情节较轻的，处五日以下拘留或者五百元以下罚款。
        　　冒充军警人员招摇撞骗的，从重处罚。 　　 <br />
        <br />
        第五十二条　有下列行为之一的，处十日以上十五日以下拘留，可以并处一千元以下罚款；情节较轻的，处五日以上十日以下拘留，可以并处五百元以下罚款:
        　　 <br />
        <br />
        （一）伪造、变造或者买卖国家机关、人民团体、企业、事业单位或者其他组织的公文、证件、证明文件、印章的；
        　　 <br />
        <br />
        （二）买卖或者使用伪造、变造的国家机关、人民团体、企业、事业单位或者其他组织的公文、证件、证明文件的；
        　　 <br />
        <br />
        （三）伪造、变造、倒卖车票、船票、航空客票、文艺演出票、体育比赛入场券或者其他有价票证、凭证的；
        　　 <br />
        <br />
        （四）伪造、变造船舶户牌，买卖或者使用伪造、变造的船舶户牌，或者涂改船舶发动机号码的。
        　　 <br />
        <br />
        第五十三条　船舶擅自进入、停靠国家禁止、限制进入的水域或者岛屿的，对船舶负责人及有关责任人员处五百元以上一千元以下罚款；情节严重的，处五日以下拘留，并处五百元以上一千元以下罚款。
        　　 <br />
        <br />
        第五十四条　有下列行为之一的，处十日以上十五日以下拘留，并处五百元以上一千元以下罚款；情节较轻的，处五日以下拘留或者五百元以下罚款:
        　　 <br />
        <br />
        （一）违反国家规定，未经注册登记，以社会团体名义进行活动，被取缔后，仍进行活动的；
        　　 <br />
        <br />
        （二）被依法撤销登记的社会团体，仍以社会团体名义进行活动的； 　　 <br />
        <br />
        （三）未经许可，擅自经营按照国家规定需要由公安机关许可的行业的。
        　　有前款 第三项行为的，予以取缔。
        　　取得公安机关许可的经营者，违反国家有关管理规定，情节严重的，公安机关可以吊销许可证。
        　　 <br />
        <br />
        第五十五条　煽动、策划非法集会、游行、示威，不听劝阻的，处十日以上十五日以下拘留。
        　　 <br />
        <br />
        第五十六条　旅馆业的工作人员对住宿的旅客不按规定登记姓名、身份证件种类和号码的，或者明知住宿的旅客将危险物质带入旅馆，不予制止的，处二百元以上五百元以下罚款。
        　　旅馆业的工作人员明知住宿的旅客是犯罪嫌疑人员或者被公安机关通缉的人员，不向公安机关报告的，处二百元以上五百元以下罚款；情节严重的，处五日以下拘留，可以并处五百元以下罚款。
        　　 <br />
        <br />
        第五十七条　房屋出租人将房屋出租给无身份证件的人居住的，或者不按规定登记承租人姓名、身份证件种类和号码的，处二百元以上五百元以下罚款。
        　　房屋出租人明知承租人利用出租房屋进行犯罪活动，不向公安机关报告的，处二百元以上五百元以下罚款；情节严重的，处五日以下拘留，可以并处五百元以下罚款。
        　　 <br />
        <br />
        第五十八条　违反关于社会生活噪声污染防治的法律规定，制造噪声干扰他人正常生活的，处警告；警告后不改正的，处二百元以上五百元以下罚款。
        　　 <br />
        <br />
        第五十九条　有下列行为之一的，处五百元以上一千元以下罚款；情节严重的，处五日以上十日以下拘留，并处五百元以上一千元以下罚款:
        　　 <br />
        <br />
        （一）典当业工作人员承接典当的物品，不查验有关证明、不履行登记手续，或者明知是违法犯罪嫌疑人、赃物，不向公安机关报告的；
        　　 <br />
        <br />
        （二）违反国家规定，收购铁路、油田、供电、电信、矿山、水利、测量和城市公用设施等废旧专用器材的；
        　　 <br />
        <br />
        （三）收购公安机关通报寻查的赃物或者有赃物嫌疑的物品的； 　　 <br />
        <br />
        （四）收购国家禁止收购的其他物品的。 　　 <br />
        <br />
        第六十条　有下列行为之一的，处五日以上十日以下拘留，并处二百元以上五百元以下罚款:
        　　 <br />
        <br />
        （一）隐藏、转移、变卖或者损毁行政执法机关依法扣押、查封、冻结的财物的；
        　　 <br />
        <br />
        （二）伪造、隐匿、毁灭证据或者提供虚假证言、谎报案情，影响行政执法机关依法办案的；
        　　 <br />
        <br />
        （三）明知是赃物而窝藏、转移或者代为销售的； 　　 <br />
        <br />
        （四）被依法执行管制、剥夺政治权利或者在缓刑、暂予监外执行中的罪犯或者被依法采取刑事强制措施的人，有违反法律、行政法规或者国务院有关部门的监督管理规定的行为。
        　　 <br />
        <br />
        第六十一条　协助组织或者运送他人偷越国
        （边）境的，处十日以上十五日以下拘留，并处一千元以上五千元以下罚款。
        　　 <br />
        <br />
        第六十二条　为偷越国
        （边）境人员提供条件的，处五日以上十日以下拘留，并处五百元以上二千元以下罚款。
        　　偷越国 （边）境的，处五日以下拘留或者五百元以下罚款。 　　 <br />
        <br />
        第六十三条　有下列行为之一的，处警告或者二百元以下罚款；情节较重的，处五日以上十日以下拘留，并处二百元以上五百元以下罚款:
        　　 <br />
        <br />
        （一）刻划、涂污或者以其他方式故意损坏国家保护的文物、名胜古迹的； 　　{" "}
        <br />
        <br />
        （二）违反国家规定，在文物保护单位附近进行爆破、挖掘等活动，危及文物安全的。
        　　 <br />
        <br />
        第六十四条　有下列行为之一的，处五百元以上一千元以下罚款；情节严重的，处十日以上十五日以下拘留，并处五百元以上一千元以下罚款:
        　　 <br />
        <br />
        （一）偷开他人机动车的； 　　 <br />
        <br />
        （二）未取得驾驶证驾驶或者偷开他人航空器、机动船舶的。 　　 <br />
        <br />
        第六十五条　有下列行为之一的，处五日以上十日以下拘留；情节严重的，处十日以上十五日以下拘留，可以并处一千元以下罚款:
        　　 <br />
        <br />
        （一）故意破坏、污损他人坟墓或者毁坏、丢弃他人尸骨、骨灰的； 　　 <br />
        <br />
        （二）在公共场所停放尸体或者因停放尸体影响他人正常生活、工作秩序，不听劝阻的。
        　　 <br />
        <br />
        第六十六条　卖淫、嫖娼的，处十日以上十五日以下拘留，可以并处五千元以下罚款；情节较轻的，处五日以下拘留或者五百元以下罚款。
        　　在公共场所拉客招嫖的，处五日以下拘留或者五百元以下罚款。 　　 <br />
        <br />
        第六十七条　引诱、容留、介绍他人卖淫的，处十日以上十五日以下拘留，可以并处五千元以下罚款；情节较轻的，处五日以下拘留或者五百元以下罚款。
        　　 <br />
        <br />
        第六十八条　制作、运输、复制、出售、出租淫秽的书刊、图片、影片、音像制品等淫秽物品或者利用计算机信息网络、电话以及其他通讯工具传播淫秽信息的，处十日以上十五日以下拘留，可以并处三千元以下罚款；情节较轻的，处五日以下拘留或者五百元以下罚款。
        　　 <br />
        <br />
        第六十九条　有下列行为之一的，处十日以上十五日以下拘留，并处五百元以上一千元以下罚款:
        　　 <br />
        <br />
        （一）组织播放淫秽音像的； 　　 <br />
        <br />
        （二）组织或者进行淫秽表演的； 　　 <br />
        <br />
        （三）参与聚众淫乱活动的。
        　　明知他人从事前款活动，为其提供条件的，依照前款的规定处罚。 　　{" "}
        <br />
        <br />
        第七十条　以营利为目的，为赌博提供条件的，或者参与赌博赌资较大的，处五日以下拘留或者五百元以下罚款；情节严重的，处十日以上十五日以下拘留，并处五百元以上三千元以下罚款。
        　　 <br />
        <br />
        第七十一条　有下列行为之一的，处十日以上十五日以下拘留，可以并处三千元以下罚款；情节较轻的，处五日以下拘留或者五百元以下罚款:
        　　 <br />
        <br />
        （一）非法种植罂粟不满五百株或者其他少量毒品原植物的； 　
        <br />
        <br />
        （二）非法买卖、运输、携带、持有少量未经灭活的罂粟等毒品原植物种子或者幼苗的；
        　　 <br />
        <br />
        （三）非法运输、买卖、储存、使用少量罂粟壳的。 　　有前款
        第一项行为，在成熟前自行铲除的，不予处罚。 　　 <br />
        <br />
        第七十二条　有下列行为之一的，处十日以上十五日以下拘留，可以并处二千元以下罚款；情节较轻的，处五日以下拘留或者五百元以下罚款:
        　　 <br />
        <br />
        （一）非法持有鸦片不满二百克、海洛因或者甲基苯丙胺不满十克或者其他少量毒品的；
        　　 <br />
        <br />
        （二）向他人提供毒品的； 　　 <br />
        <br />
        （三）吸食、注射毒品的； 　　 <br />
        <br />
        （四）胁迫、欺骗医务人员开具麻醉药品、精神药品的。 　　 <br />
        <br />
        第七十三条　教唆、引诱、欺骗他人吸食、注射毒品的，处十日以上十五日以下拘留，并处五百元以上二千元以下罚款。
        　　 <br />
        <br />
        第七十四条　旅馆业、饮食服务业、文化娱乐业、出租汽车业等单位的人员，在公安机关查处吸毒、赌博、卖淫、嫖娼活动时，为违法犯罪行为人通风报信的，处十日以上十五日以下拘留。
        　　 <br />
        <br />
        第七十五条　饲养动物，干扰他人正常生活的，处警告；警告后不改正的，或者放任动物恐吓他人的，处二百元以上五百元以下罚款。
        　　驱使动物伤害他人的，依照本法 第四十三条 第一款的规定处罚。 　　{" "}
        <br />
        <br />
        第七十六条　有本法 第六十七条、 第六十八条、
        第七十条的行为，屡教不改的，可以按照国家规定采取强制性教育措施。
        <br />
        <br />
        第四章　处罚程序 <br />
        <br />
        第一节　调查 　　 <br />
        <br />
        第七十七条　公安机关对报案、控告、举报或者违反治安管理行为人主动投案，以及其他行政主管部门、司法机关移送的违反治安管理案件，应当及时受理，并进行登记。
        　　 <br />
        <br />
        第七十八条　公安机关受理报案、控告、举报、投案后，认为属于违反治安管理行为的，应当立即进行调查；认为不属于违反治安管理行为的，应当告知报案人、控告人、举报人、投案人，并说明理由。
        　　 <br />
        <br />
        第七十九条　公安机关及其人民警察对治安案件的调查，应当依法进行。严禁刑讯逼供或者采用威胁、引诱、欺骗等非法手段收集证据。
        　　以非法手段收集的证据不得作为处罚的根据。 　　 <br />
        <br />
        第八十条　公安机关及其人民警察在办理治安案件时，对涉及的国家秘密、商业秘密或者个人隐私，应当予以保密。
        　　 <br />
        <br />
        第八十一条　人民警察在办理治安案件过程中，遇有下列情形之一的，应当回避；违反治安管理行为人、被侵害人或者其法定代理人也有权要求他们回避:
        　　 <br />
        <br />
        （一）是本案当事人或者当事人的近亲属的； 　　 <br />
        <br />
        （二）本人或者其近亲属与本案有利害关系的； 　　 <br />
        <br />
        （三）与本案当事人有其他关系，可能影响案件公正处理的。
        　　人民警察的回避，由其所属的公安机关决定；公安机关负责人的回避，由上一级公安机关决定。
        　　 <br />
        <br />
        第八十二条　需要传唤违反治安管理行为人接受调查的，经公安机关办案部门负责人批准，使用传唤证传唤。对现场发现的违反治安管理行为人，人民警察经出示工作证件，可以口头传唤，但应当在询问笔录中注明。
        　　公安机关应当将传唤的原因和依据告知被传唤人。对无正当理由不接受传唤或者逃避传唤的人，可以强制传唤。
        　　 <br />
        <br />
        第八十三条　对违反治安管理行为人，公安机关传唤后应当及时询问查证，询问查证的时间不得超过八小时；情况复杂，依照本法规定可能适用行政拘留处罚的，询问查证的时间不得超过二十四小时。
        　　公安机关应当及时将传唤的原因和处所通知被传唤人家属。 　　 <br />
        <br />
        第八十四条　询问笔录应当交被询问人核对；对没有阅读能力的，应当向其宣读。记载有遗漏或者差错的，被询问人可以提出补充或者更正。被询问人确认笔录无误后，应当签名或者盖章，询问的人民警察也应当在笔录上签名。
        　　被询问人要求就被询问事项自行提供书面材料的，应当准许；必要时，人民警察也可以要求被询问人自行书写。
        　　询问不满十六周岁的违反治安管理行为人，应当通知其父母或者其他监护人到场。
        　　 <br />
        <br />
        第八十五条　人民警察询问被侵害人或者其他证人，可以到其所在单位或者住处进行；必要时，也可以通知其到公安机关提供证言。
        　　人民警察在公安机关以外询问被侵害人或者其他证人，应当出示工作证件。
        　　询问被侵害人或者其他证人，同时适用本法 第八十四条的规定。 　　{" "}
        <br />
        <br />
        第八十六条　询问聋哑的违反治安管理行为人、被侵害人或者其他证人，应当有通晓手语的人提供帮助，并在笔录上注明。
        　　询问不通晓当地通用的语言文字的违反治安管理行为人、被侵害人或者其他证人，应当配备翻译人员，并在笔录上注明。
        　　 <br />
        <br />
        第八十七条　公安机关对与违反治安管理行为有关的场所、物品、人身可以进行检查。检查时，人民警察不得少于二人，并应当出示工作证件和县级以上人民政府公安机关开具的检查证明文件。对确有必要立即进行检查的，人民警察经出示工作证件，可以当场检查，但检查公民住所应当出示县级以上人民政府公安机关开具的检查证明文件。
        　　检查妇女的身体，应当由女性工作人员进行。 　　 <br />
        <br />
        第八十八条　检查的情况应当制作检查笔录，由检查人、被检查人和见证人签名或者盖章；被检查人拒绝签名的，人民警察应当在笔录上注明。
        　　 <br />
        <br />
        第八十九条　公安机关办理治安案件，对与案件有关的需要作为证据的物品，可以扣押；对被侵害人或者善意{" "}
        第三人合法占有的财产，不得扣押，应当予以登记。对与案件无关的物品，不得扣押。
        　　对扣押的物品，应当会同在场见证人和被扣押物品持有人查点清楚，当场开列清单一式二份，由调查人员、见证人和持有人签名或者盖章，一份交给持有人，另一份附卷备查。
        　　对扣押的物品，应当妥善保管，不得挪作他用；对不宜长期保存的物品，按照有关规定处理。经查明与案件无关的，应当及时退还；经核实属于他人合法财产的，应当登记后立即退还；满六个月无人对该财产主张权利或者无法查清权利人的，应当公开拍卖或者按照国家有关规定处理，所得款项上缴国库。
        　　 <br />
        <br />
        第九十条　为了查明案情，需要解决案件中有争议的专门性问题的，应当指派或者聘请具有专门知识的人员进行鉴定；鉴定人鉴定后，应当写出鉴定意见，并且签名。
        <br />
        <br />
        第二节　决定 　　 <br />
        <br />
        第九十一条　治安管理处罚由县级以上人民政府公安机关决定；其中警告、五百元以下的罚款可以由公安派出所决定。
        　　 <br />
        <br />
        第九十二条　对决定给予行政拘留处罚的人，在处罚前已经采取强制措施限制人身自由的时间，应当折抵。限制人身自由一日，折抵行政拘留一日。
        　　 <br />
        <br />
        第九十三条　公安机关查处治安案件，对没有本人陈述，但其他证据能够证明案件事实的，可以作出治安管理处罚决定。但是，只有本人陈述，没有其他证据证明的，不能作出治安管理处罚决定。
        　　 <br />
        <br />
        第九十四条　公安机关作出治安管理处罚决定前，应当告知违反治安管理行为人作出治安管理处罚的事实、理由及依据，并告知违反治安管理行为人依法享有的权利。
        　　违反治安管理行为人有权陈述和申辩。公安机关必须充分听取违反治安管理行为人的意见，对违反治安管理行为人提出的事实、理由和证据，应当进行复核；违反治安管理行为人提出的事实、理由或者证据成立的，公安机关应当采纳。
        　　公安机关不得因违反治安管理行为人的陈述、申辩而加重处罚。 　　 <br />
        <br />
        第九十五条　治安案件调查结束后，公安机关应当根据不同情况，分别作出以下处理:
        　　 <br />
        <br />
        （一）确有依法应当给予治安管理处罚的违法行为的，根据情节轻重及具体情况，作出处罚决定；
        　　 <br />
        <br />
        （二）依法不予处罚的，或者违法事实不能成立的，作出不予处罚决定； 　　{" "}
        <br />
        <br />
        （三）违法行为已涉嫌犯罪的，移送主管机关依法追究刑事责任； 　　 <br />
        <br />
        （四）发现违反治安管理行为人有其他违法行为的，在对违反治安管理行为作出处罚决定的同时，通知有关行政主管部门处理。
        　　 <br />
        <br />
        第九十六条　公安机关作出治安管理处罚决定的，应当制作治安管理处罚决定书。决定书应当载明下列内容:
        　　 <br />
        <br />
        （一）被处罚人的姓名、性别、年龄、身份证件的名称和号码、住址； 　　{" "}
        <br />
        <br />
        （二）违法事实和证据； 　　 <br />
        <br />
        （三）处罚的种类和依据； 　　 <br />
        <br />
        （四）处罚的执行方式和期限； 　　 <br />
        <br />
        （五）对处罚决定不服，申请行政复议、提起行政诉讼的途径和期限； 　　{" "}
        <br />
        <br />
        （六）作出处罚决定的公安机关的名称和作出决定的日期。
        　　决定书应当由作出处罚决定的公安机关加盖印章。 　　 <br />
        <br />
        第九十七条　公安机关应当向被处罚人宣告治安管理处罚决定书，并当场交付被处罚人；无法当场向被处罚人宣告的，应当在二日内送达被处罚人。决定给予行政拘留处罚的，应当及时通知被处罚人的家属。
        　　有被侵害人的，公安机关应当将决定书副本抄送被侵害人。 　　 <br />
        <br />
        第九十八条　公安机关作出吊销许可证以及处二千元以上罚款的治安管理处罚决定前，应当告知违反治安管理行为人有权要求举行听证；违反治安管理行为人要求听证的，公安机关应当及时依法举行听证。
        　　 <br />
        <br />
        第九十九条　公安机关办理治安案件的期限，自受理之日起不得超过三十日；案情重大、复杂的，经上一级公安机关批准，可以延长三十日。
        　　为了查明案情进行鉴定的期间，不计入办理治安案件的期限。 　　 <br />
        <br />
        第一百条　违反治安管理行为事实清楚，证据确凿，处警告或者二百元以下罚款的，可以当场作出治安管理处罚决定。
        　　 <br />
        <br />
        第一百零一条　当场作出治安管理处罚决定的，人民警察应当向违反治安管理行为人出示工作证件，并填写处罚决定书。处罚决定书应当当场交付被处罚人；有被侵害人的，并将决定书副本抄送被侵害人。
        　　前款规定的处罚决定书，应当载明被处罚人的姓名、违法行为、处罚依据、罚款数额、时间、地点以及公安机关名称，并由经办的人民警察签名或者盖章。
        　　当场作出治安管理处罚决定的，经办的人民警察应当在二十四小时内报所属公安机关备案。
        　　 <br />
        <br />
        第一百零二条　被处罚人对治安管理处罚决定不服的，可以依法申请行政复议或者提起行政诉讼。
        <br />
        <br />
        第三节　执行 　　 <br />
        <br />
        第一百零三条　对被决定给予行政拘留处罚的人，由作出决定的公安机关送达拘留所执行。
        　　 <br />
        <br />
        第一百零四条　受到罚款处罚的人应当自收到处罚决定书之日起十五日内，到指定的银行缴纳罚款。但是，有下列情形之一的，人民警察可以当场收缴罚款:
        　　 <br />
        <br />
        （一）被处五十元以下罚款，被处罚人对罚款无异议的； 　　 <br />
        <br />
        （二）在边远、水上、交通不便地区，公安机关及其人民警察依照本法的规定作出罚款决定后，被处罚人向指定的银行缴纳罚款确有困难，经被处罚人提出的；
        　　 <br />
        <br />
        （三）被处罚人在当地没有固定住所，不当场收缴事后难以执行的。 　　 <br />
        <br />
        第一百零五条　人民警察当场收缴的罚款，应当自收缴罚款之日起二日内，交至所属的公安机关；在水上、旅客列车上当场收缴的罚款，应当自抵岸或者到站之日起二日内，交至所属的公安机关；公安机关应当自收到罚款之日起二日内将罚款缴付指定的银行。
        　　 <br />
        <br />
        第一百零六条　人民警察当场收缴罚款的，应当向被处罚人出具省、自治区、直辖市人民政府财政部门统一制发的罚款收据；不出具统一制发的罚款收据的，被处罚人有权拒绝缴纳罚款。
        　　 <br />
        <br />
        第一百零七条　被处罚人不服行政拘留处罚决定，申请行政复议、提起行政诉讼的，可以向公安机关提出暂缓执行行政拘留的申请。公安机关认为暂缓执行行政拘留不致发生社会危险的，由被处罚人或者其近亲属提出符合本法{" "}
        <br />
        <br />
        第一百零八条规定条件的担保人，或者按每日行政拘留二百元的标准交纳保证金，行政拘留的处罚决定暂缓执行。
        　　 <br />
        <br />
        第一百零八条　担保人应当符合下列条件: 　　 <br />
        <br />
        （一）与本案无牵连； 　　 <br />
        <br />
        （二）享有政治权利，人身自由未受到限制； 　　 <br />
        <br />
        （三）在当地有常住户口和固定住所； 　　 <br />
        <br />
        （四）有能力履行担保义务。 　　 <br />
        <br /> <br />
        <br />
        第一百零九条　担保人应当保证被担保人不逃避行政拘留处罚的执行。
        　　担保人不履行担保义务，致使被担保人逃避行政拘留处罚的执行的，由公安机关对其处三千元以下罚款。
        　　 <br />
        <br /> <br />
        <br />
        第一百一十条　被决定给予行政拘留处罚的人交纳保证金，暂缓行政拘留后，逃避行政拘留处罚的执行的，保证金予以没收并上缴国库，已经作出的行政拘留决定仍应执行。
        　　 <br />
        <br /> <br />
        <br />
        第一百一十一条　行政拘留的处罚决定被撤销，或者行政拘留处罚开始执行的，公安机关收取的保证金应当及时退还交纳人。
        <br />
        <br /> <br />
        <br />
        第五章　执法监督 　　 <br />
        <br /> <br />
        <br />
        第一百一十二条　公安机关及其人民警察应当依法、公正、严格、高效办理治安案件，文明执法，不得徇私舞弊。
        　　 <br />
        <br /> <br />
        <br />
        第一百一十三条　公安机关及其人民警察办理治安案件，禁止对违反治安管理行为人打骂、虐待或者侮辱。
        　　 <br />
        <br /> <br />
        <br />
        第一百一十四条　公安机关及其人民警察办理治安案件，应当自觉接受社会和公民的监督。
        　　公安机关及其人民警察办理治安案件，不严格执法或者有违法违纪行为的，任何单位和个人都有权向公安机关或者人民检察院、行政监察机关检举、控告；收到检举、控告的机关，应当依据职责及时处理。
        　　 <br />
        <br /> <br />
        <br />
        第一百一十五条　公安机关依法实施罚款处罚，应当依照有关法律、行政法规的规定，实行罚款决定与罚款收缴分离；收缴的罚款应当全部上缴国库。
        　　 <br />
        <br /> <br />
        <br />
        第一百一十六条　人民警察办理治安案件，有下列行为之一的，依法给予行政处分；构成犯罪的，依法追究刑事责任:
        　　 <br />
        <br />
        （一）刑讯逼供、体罚、虐待、侮辱他人的； 　　 <br />
        <br />
        （二）超过询问查证的时间限制人身自由的； 　　 <br />
        <br />
        （三）不执行罚款决定与罚款收缴分离制度或者不按规定将罚没的财物上缴国库或者依法处理的；
        　　 <br />
        <br />
        （四）私分、侵占、挪用、故意损毁收缴、扣押的财物的； 　　 <br />
        <br />
        （五）违反规定使用或者不及时返还被侵害人财物的； 　　 <br />
        <br />
        （六）违反规定不及时退还保证金的； 　　 <br />
        <br />
        （七）利用职务上的便利收受他人财物或者谋取其他利益的； 　　 <br />
        <br />
        （八）当场收缴罚款不出具罚款收据或者不如实填写罚款数额的； 　　 <br />
        <br />
        （九）接到要求制止违反治安管理行为的报警后，不及时出警的； 　　 <br />
        <br />
        （十）在查处违反治安管理活动时，为违法犯罪行为人通风报信的； 　　 <br />
        <br />
        （十一）有徇私舞弊、滥用职权，不依法履行法定职责的其他情形的。
        　　办理治安案件的公安机关有前款所列行为的，对直接负责的主管人员和其他直接责任人员给予相应的行政处分。
        　　 <br />
        <br /> <br />
        <br />
        第一百一十七条　公安机关及其人民警察违法行使职权，侵犯公民、法人和其他组织合法权益的，应当赔礼道歉；造成损害的，应当依法承担赔偿责任。
        <br />
        <br /> <br />
        <br />
        第六章　附则 　　 <br />
        <br /> <br />
        <br />
        第一百一十八条　本法所称以上、以下、以内，包括本数。 　　 <br />
        <br />
        第一百一十九条　本法自2006年3月1日起施行。1986年9月5日公布、1994年5月12日修订公布的《中华人民共和国治安管理处罚条例》同时废止。
      </div>

      <br />
    </div>
  );
};
